import { useCompDocuments } from '../hooks/useCompDocuments';

export const useCompsForAppraisalCompare = () => {
  return useCompDocuments();
};
